import * as Yup from "yup";

export type CreationMethod = "prospect" | "client" | "position";

export type CaseInfoFormValues = {
  creationMethod: CreationMethod;
  prospectIdOrSubscriptionUrl: string;
  positionId: string;
  clientId?: string;
  clientName?: string;
  entityId?: string;
  entityName?: string;
  programName: string;
  assignToMyself: boolean;
};

export const schema: Yup.ObjectSchema<CaseInfoFormValues> = Yup.object({
  creationMethod: Yup.mixed<CreationMethod>().required().default("prospect"),
  prospectIdOrSubscriptionUrl: Yup.string().default(""),
  positionId: Yup.string().trim().default(""),
  clientId: Yup.string().required("Client is required"),
  entityId: Yup.string().required("Entity is required"),
  clientName: Yup.string().default(""),
  entityName: Yup.string().default(""),
  programName: Yup.string().default(""),
  assignToMyself: Yup.boolean().default(false),
});
